import React, { useState, useEffect } from 'react';
import { softwarePageData } from '../data/pageData';
import PageTitle from '../components/PageTitle';

const SoftwarePage = () => {
    const data = softwarePageData;
    return (
        <div className="bg-white text-gray-800">
            <PageTitle title={data.pageTitle} breadcrumbs={data.breadcrumbs} />
            <section className="py-16 md:py-24">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <p className="text-center text-gray-600 mb-12 max-w-3xl mx-auto text-lg leading-relaxed">{data.introText}</p>
                     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {data.services.map((service, index) => (
                            <div 
                                key={service.name} 
                                className="bg-gray-50 text-gray-800 rounded-xl shadow-2xl overflow-hidden flex flex-col group transform hover:scale-105 transition-all duration-300 border border-gray-200 hover:border-yellow-500"
                                style={{ animationDelay: `${index * 100}ms` }}
                            >
                                <div className="relative overflow-hidden h-64">
                                    <img src={service.img} alt={service.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"/>
                                </div>
                                <div className="p-6 flex flex-col flex-grow">
                                    <h3 className="text-xl font-bold text-gray-900 mb-3">{service.name}</h3>
                                    <p className="text-gray-700 text-sm mb-5 flex-grow leading-relaxed">{service.desc}</p>
                                     <button className="mt-auto bg-yellow-500 hover:bg-yellow-600 text-black font-bold px-6 py-3 rounded-md text-sm w-full transition-colors duration-300 transform group-hover:scale-105">
                                         Explore Service
                                     </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default SoftwarePage;